const descriptions = [
    {
        id: 'e_merket',
        description: `
            E-merket er den lille bokstaven «e» som du ser rett etter vekt- eller volumangivelsen på ferdigpakninger i EU/EØS.
            <br><br>
            Det betyr at produktet er fylt etter gjennomsnittssystemet – altså at gjennomsnittlig innhold ikke er lavere enn det som står på pakken, og at avvik alltid ligger innenfor lovpålagte toleranser. For deg som kunde betyr det trygghet for at du får den mengden du betaler for. Før produkter kan merkes med «e», må forpakker eller importør melde dette til Justervesenet og sikre at jevnlig kontroll av fyllmengden blir utført.`
    }
];

export function getBrandSchemeDescription(id: string): string | undefined {
    return descriptions.find(x => x.id === id)?.description;
}
